import {
  GreyGrey70,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  InputSelectControlField,
  TextInputField,
  RadioButtonGroupField
} from '@sequencehq/core-components'
import { useGraduatedPriceForm } from './useGraduatedPriceForm'
import { PricingModelField } from '../common/PricingModelField'
import { Currency } from '@sequencehq/api'
import { UsageMetricParameterFields } from '../common/UsageMetrics/UsageMetricParameterFields'
import { FixedTierTableInput } from '../common/inputs/FixedTierTableInput/FixedTierTableInput'
import { PercentageTierTableInput } from '../common/inputs/PercentageTierTableInput/PercentageTierTableInput'
import { UsageTierType } from 'common/drawers/PricingEditor/domain'
import UsageCalculationPeriodDropdown from 'common/drawers/PricingEditor/view/editors/GraduatedPrice/UsageCalculationPeriodDropdown/UsageCalculationPeriodDropdown.tsx'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { BillingFrequencyField } from '../common/BillingFrequencyField'
import { ProductSelectField } from '../common/ProductSelectField'
import { CopyPricingTableButton } from '../common/CopyPricingTableButton'
import { UsageMetricSelect } from 'UsageMetrics/index'

export const GraduatedPriceForm = () => {
  const { fieldsConfig, currency } = useGraduatedPriceForm()

  return (
    <>
      <Flex direction="column" gap="16px">
        <ProductSelectField />

        <PricingModelField />

        <TextInputField
          label="Display name (appears on invoice)"
          data-testid="graduated.name"
          value={fieldsConfig.name.value}
          onChange={e => fieldsConfig.name.onChange(e.target.value)}
          validationErrors={fieldsConfig.name.validationErrors}
          isDisabled={fieldsConfig.name.disabled}
          placeholder="Enter a display name"
        />

        <BillingFrequencyField
          data-testid="graduated.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />
        <UsageMetricSelect
          data-testid="graduated.usageMetric"
          validationErrors={fieldsConfig.usageMetricId.validationErrors}
          value={fieldsConfig.usageMetricId.value}
          onChange={fieldsConfig.usageMetricId.onChange}
          isDisabled={fieldsConfig.usageMetricId.disabled}
        />
        <UsageMetricParameterFields
          fieldsConfig={fieldsConfig}
          usageMetricId={fieldsConfig.usageMetricId.value}
        ></UsageMetricParameterFields>
        <RadioButtonGroupField
          label="Type"
          data-testid="graduated.usageTierType"
          value={fieldsConfig.usageTierType.value}
          options={fieldsConfig.usageTierType.options}
          onChange={newValue =>
            fieldsConfig.usageTierType.onChange(newValue as UsageTierType)
          }
          validationErrors={fieldsConfig.usageTierType.validationErrors}
          isDisabled={fieldsConfig.usageTierType.disabled}
          fullWidth
        />
        <Box width="100%">
          <Flex gap={4} alignItems="center" marginBottom="8px">
            <Box {...Primary13SemiBold} color={GreyGrey70}>
              Tiers
            </Box>
            {!fieldsConfig.currency.hidden && (
              <InputSelectControlField
                data-testid="graduated.currency"
                value={fieldsConfig.currency.value}
                onChange={newCurrency =>
                  fieldsConfig.currency.onChange(newCurrency as Currency)
                }
                options={fieldsConfig.currency.options}
                validationErrors={fieldsConfig.currency.validationErrors}
                disabled={fieldsConfig.currency.disabled}
                placeholder="Select currency"
                width="90px"
              />
            )}
            <Flex grow="1"></Flex>
            <CopyPricingTableButton
              data={
                fieldsConfig.usageTierType.value === 'FIXED'
                  ? { tiers: fieldsConfig.tiers.value, currency }
                  : {
                      percentageTiers: fieldsConfig.percentageTiers.value,
                      currency,
                      isGraduated: true
                    }
              }
              data-testid="graduated.copyPricingTable"
            />
          </Flex>
          {fieldsConfig.usageTierType.value === 'FIXED' ? (
            <FixedTierTableInput
              value={fieldsConfig.tiers.value}
              onChange={fieldsConfig.tiers.onChange}
              isDisabled={fieldsConfig.tiers.disabled}
              currency={currency}
              validationErrors={fieldsConfig.tiers.validationErrors}
            />
          ) : (
            <PercentageTierTableInput
              value={fieldsConfig.percentageTiers.value}
              onChange={fieldsConfig.percentageTiers.onChange}
              isDisabled={fieldsConfig.percentageTiers.disabled}
              currency={currency}
              validationErrors={fieldsConfig.percentageTiers.validationErrors}
            />
          )}
        </Box>

        {!fieldsConfig.usageCalculationPeriod.hidden && (
          <UsageCalculationPeriodDropdown
            options={fieldsConfig.usageCalculationPeriod.options}
            value={fieldsConfig.usageCalculationPeriod.value}
            isDisabled={fieldsConfig.usageCalculationPeriod.disabled}
            onChange={fieldsConfig.usageCalculationPeriod.onChange}
            validationErrors={
              fieldsConfig.usageCalculationPeriod.validationErrors
            }
            data-testid="graduated.usageCalculationPeriod"
          />
        )}

        <ExternalLedgerForm />
      </Flex>
    </>
  )
}
